import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"bv-form-layout__item\" ...attributes>\n  {{yield}}\n</div>")